import { CommunityId } from "@sp-crm/core";
import { ContentFull, ContentSection2Up, ContentSectionColumn } from "components/layout";
import { NgGrid } from "components/shared/grid";
import { Spinner } from "components/ui/spinner";
import { useFindOrCreateCommunityInsightsMutation } from "generated/graphql";
import React, { useEffect } from "react";
import { useProductName } from "store/selectors/branding";
import { CommunityInsightsAvailability } from "./community-insights-availability";
import { CommunityInsightsDetails } from "./community-insights-details";
import { CommunityInsightsDisclaimer } from "./community-insights-disclaimer";
import { CommunityInsightsPricing } from "./community-insights-pricing";
import { CommunityInsightsReviews } from "./community-insights-reviews";

const NoListing = () => {
    const productName = useProductName();

    return (
        <ContentSectionColumn>
            <ContentFull>
                This community was created by your agency and is not yet linked to{" "}
                {productName} Community Insights.
            </ContentFull>
        </ContentSectionColumn>
    );
};

interface CommunityInsightsTabProps {
    communityId: CommunityId;
}

export const CommunityInsightsTab: React.FC<CommunityInsightsTabProps> = props => {
    const { communityId } = props;
    const findOrCreateCommunityInsights = useFindOrCreateCommunityInsightsMutation();

    useEffect(() => {
        findOrCreateCommunityInsights.mutateAsync({ communityId });
    }, [communityId]); // eslint-disable-line react-hooks/exhaustive-deps

    const listing = findOrCreateCommunityInsights.data?.findOrCreateCommunityInsights;

    if (findOrCreateCommunityInsights.isLoading || !findOrCreateCommunityInsights.data) {
        return (
            <ContentSection2Up>
                <ContentSectionColumn>
                    <ContentFull>
                        <div className="flex items-center justify-center">
                            <Spinner />
                        </div>
                    </ContentFull>
                </ContentSectionColumn>
            </ContentSection2Up>
        );
    }

    return (
        <NgGrid>
            {listing ? (
                <>
                    <NgGrid.Column>
                        <ContentFull>
                            <CommunityInsightsDetails
                                communityId={communityId}
                                listing={listing}
                            />
                        </ContentFull>
                        <ContentFull>
                            <CommunityInsightsAvailability
                                listing={listing}
                                communityId={communityId}
                            />
                        </ContentFull>{" "}
                        <ContentFull>
                            <CommunityInsightsPricing
                                listing={listing}
                                communityId={communityId}
                            />
                        </ContentFull>
                        <ContentFull>
                            <CommunityInsightsDisclaimer />
                        </ContentFull>
                    </NgGrid.Column>
                    <NgGrid.Column>
                        <ContentFull>
                            <CommunityInsightsReviews
                                communityId={communityId}
                                showHeader={true}
                            />
                        </ContentFull>
                    </NgGrid.Column>
                </>
            ) : (
                <NoListing />
            )}
        </NgGrid>
    );
};
